<template>
  <div>
    <sort-by-button
      class="schedules-tab__sortby-button"
      :disableSortBy="true"
    />
    <empty-state
      class="schedules-tab__empty-message"
      v-if="emptyResponse"
      :feed-id="feedId"
      :empty-state="EMPTY_STATE_SCHEDULES"
      :view="view"
      v-on="$listeners"
    />
    <div class="schedules-tab__cards" v-else>
      <schedule-card
        v-for="(schedule, index) in schedules"
        :key="index"
        :schedule="schedule"
      />
    </div>
  </div>
</template>

<script>
import EmptyState from './helpers/EmptyState.vue'
import SortByButton from './helpers/SortByButton.vue'
import ScheduleCard from './helpers/ScheduleCard.vue'
import { EMPTY_STATE_SCHEDULES } from '../config/constants'

export default {
  name: 'SchedulesTab',
  components: {
    EmptyState,
    SortByButton,
    ScheduleCard,
  },
  props: {
    schedules: {
      type: Array,
      default: () => [],
    },
    feedId: {
      type: String,
      default: '',
    },
    emptyResponse: Boolean,
    view: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      EMPTY_STATE_SCHEDULES,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@mds/constants';
@import '@mds/typography';

.schedules-tab {
  &__empty-message {
    margin: $mds-space-8-x auto 0 auto;
    color: $mds-text-color-secondary;
  }
  &__sortby-button {
    display: flex;
    flex-direction: row;
    padding: $mds-space-1-and-a-half-x $mds-space-1-and-a-half-x 0;
    :first-child {
      @include mds-body-text-s();
      color: $mds-text-color-secondary;
      margin: 0;
    }
    &::v-deep [class^='mds-button'] {
      padding: 0;
      padding-left: $mds-space-half-x;
      > span {
        font-weight: 600;
      }
    }
  }
  &__cards {
    display: flex;
    flex-wrap: wrap;
    overflow-y: auto;
    max-height: calc(100vh - 115px);
    padding: $mds-space-1-and-a-half-x;
    &::v-deep [class^='mds-card'] {
      margin-top: $mds-space-1-x;
      padding: $mds-space-1-x;
      width: 100%;
      > h2 {
        padding: 0;
        margin-top: 0;
      }
    }
  }
}
</style>
